import { language } from "./language";

const fas: language = {
  translation: {
    "Actual size": "سایز اصلی",
    "Add area": "ناحیه اضافه کنید",
    "Annotation mode": "حالت گروه توضیحی",
    Cancel: "لفو کردن",
    Categories: "دسته بندی کردن",
    "Center image automatically":
      "تصویر را به طور اتوماتیک در مرکز قرار می دهد",
    "Color annotation": "توضیح رنگ ها",
    "Create category": "ایجاد دسته بندی",
    "Create new classifier": "ایجاد طبقه بندی جدید",
    Create: "ایجاد",
    "Delete category": "پاک کردن دسته بندی",
    "Delete images": "پاک کردن تصویر",
    Description: "توضیحات",
    Edit: "ویرایش",
    "Edit category": "ویرایش دسته بندی",
    "Elliptical annotation": "گروه توضیحی بیضوی",
    Export: "فرستادن",
    "Export annotations": "فرستادن گروه توضیحی",
    "Freehand annotation": "گروه توضیحی آزاد",
    Help: "کمک یابی",
    "Hide category": "پنهان سازی طبقه بندی",
    "Hide other categories": "پنهان سازی سایر طبقه بندی ها",
    "Hide sidebar": "پنهان سازی منوی کناری",
    "Import images": "آوردن تصاویر",
    Intersection: "تلاقی کردن",
    "Invert annotation": "معکوس کردن گروه توضیحی",
    "Lasso annotation": "گروه توضیحی کمند",
    Logo: "علامت",
    "Magnetic annotation": "گروه توضیحی آهنربایی",
    Model: "نمونه",
    "Object annotation": "گروه توضیحی هدف",
    "Open classifier": "باز کردن طبقه بندی",
    "Open example classifier": "باز کردن طبقه بندی نمونه",
    "Open image": "باز کردن تصویر",
    "Open weights": "باز کردن وزن ها",
    Open: "باز کردن",
    "Pen annotation": "گروه توضیحی خودکار",
    Pointer: "نشانه گر",
    "Polygonal annotation": "گروه توضیحی چند ظلعی",
    Name: "نام",
    "New annotation": "گروه توضیحی جدید",
    "Quick annotation": "گروه توضیحی سریع",
    "Rectangular annotation": "گروه توضیحی مستطیلی",
    "Run classifier": "اجرا کردن طبقه بندی",
    "Save annotations and predictions":
      "ذخیره کردن گروه های توضیحی و پیش بینی ها",
    "Save classifier": "ذخیره کردن طبقه بندی",
    "Save weights": "ذخیره کردن وزن ها",
    Save: "ذخیره کردن",
    "Search images": "جستجوی تصاویر",
    "Send feedback": "فرستادن پیشنهادات",
    Settings: "تنظیمات",
    "Show category": "نشان دادن گروه ها",
    "Show sidebar": "نشان دادن منوی کناری",
    "Subtract area": "کم کردن ناحیه",
    Unknown: "تعریف نشده",
    Zoom: "بزرگ نمایی",
    "Zoom in": "بزرگ نمایی کردن",
    "Zoom mode": "حالت بزرگ نمایی",
    "Zoom out": "کوچک نمایی کردن",
  },
};

export default fas;
